import { useSessionStorage } from '@wolfdanepug/common-react'
import ActiveSegment from '../ActiveSegment'
import StripeCheckout from '../Stripe/StripeCheckout'

export default function Checkout({ cart, data }: any) {
	const [checkoutState, setCheckoutState]: any = useSessionStorage('checkout', {})

	return (
		<>
			<ActiveSegment segment="checkout" />
			<StripeCheckout cart={cart} data={data} state={checkoutState} saveState={setCheckoutState} />
		</>
	)
}
